<template>
  <v-dialog class="mt-0" v-model="isOpenApplicationList"
    fullscreen hide-overlay transition="slide-x-transition">
    <v-card tile>
      <v-app-bar
        app
        clipped-left
        clipped-right
        color="white"
        class="px-8 mt-0"
        elevation="0"
        style="boxShadow: 0px 6px 35px rgba(0, 0, 0, 0.2) !important;"
      >
        <v-btn icon @click="openApplicationList(false)" color="secondary">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title class="secondary--text font-weight-bold pl-1">APPS</v-toolbar-title>
      </v-app-bar>
      <v-content class="px-0">
        <main-menu></main-menu>
      </v-content>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import MainMenu from '@/components/Menu.vue';

export default {
  components: {
    'main-menu': MainMenu,
  },
  computed: {
    ...mapState(['isOpenApplicationList']),
  },
  methods: {
    ...mapMutations(['openApplicationList']),
  },
};
</script>
